import { createApp } from 'vue'
import App from './App.vue'
import store from './store';
import router from './router';

// Toastification (Vue3)
import Toast, { createToastInterface } from "vue-toastification";
import "vue-toastification/dist/index.css";

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import './assets/theme.css';

import {TIPSTAG_SUCCESS,TIPSTAG_INFO,TIPSTAG_WARNING,TIPSTAG_ERROR} from '@/constants';

import * as ElementPlusIconsVue from '@element-plus/icons-vue'


const toastOptions = {    
  position: 'top-center',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: 'button',
  icon: true,
  rtl: false,     
};

const app = createApp(App)
  .use(store)
  .use(router)
  .use(ElementPlus);
  
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
      app.component(key, component)
    }

// register plugin
app.use(Toast, toastOptions);

// create a toast interface instance so main.js can call toasts immediately
// and ensure globalProperties.$toast is always available
const toastInterface = createToastInterface(toastOptions);
app.config.globalProperties.$toast = toastInterface;

app.config.globalProperties.$handleTips = function(tag, msg, errors) {
  // prefer injected $toast, fallback to the created interface
  const toast = app.config.globalProperties.$toast || toastInterface;
  if (!toast) {
    console.warn('Toast not available', tag, msg);
    errors[tag] = msg;
    return errors;
  }

  switch(tag) {
    case TIPSTAG_SUCCESS:
      toast.success(msg);
      errors[tag] = '';
      break;
    case TIPSTAG_INFO:
      toast.info(msg);
      errors[tag] = '';
      break;
    case TIPSTAG_WARNING:
      toast.warning(msg);
      errors[tag] = '';
      break;
    case TIPSTAG_ERROR:
      toast.error(msg);
      errors[tag] = '';
      break;    
    default:
      // default show as basic toast
      if (typeof toast === 'function') {
        // createToastInterface returns function-like too
        toast(msg);
      } else if (toast.info) {
        toast.info(msg);
      }
      errors[tag] = '';
      break;
  }

  return errors;
};

app.mount('#app');
